export default __webpack_public_path__ + "images/13036f5714a28ba5a27342decd81f046-navigating_this_challenging_health_care_system.svg";